export default "__VITE_ASSET__txUqbRlq__"